import { DocumentCloser } from "../types";
import { closeAvailable } from "../shared/closeSupport";

// Closing the workbook after a check in: ExcelApi 1.11's Workbook.close. Closed WITHOUT
// saving -- the content has just been published to Jylo, and a save would aim at the
// read-only draft URL the workbook was opened from.

export const excelCloser: DocumentCloser = {
  isAvailable: () => closeAvailable("ExcelApi", "1.11", { web: true }),
  close: () =>
    Excel.run(async (context) => {
      context.workbook.close(Excel.CloseBehavior.skipSave);
      await context.sync();
    }),
};
